<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003736')" prop="ymsDistributorMerchantId">
              <Input v-model.trim="pageParams.ymsDistributorMerchantId" clearable></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003737')">
              <Date-picker
                type="datetimerange"
                class="wid100P"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="rechargeTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003738')" prop="status">
              <Select v-model="pageParams.status" filterable>
                <Option v-for="item in rechargeType" :value="item.value">{{ item.label }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003739')" prop="ymsDistributorMerchantRechargeRecordIds">
              <Input type="textarea" :placeholder="$t('key1003740')" v-model.trim="pageParams.ymsDistributorMerchantRechargeRecordIds"></Input>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--充值按钮-->
      <Button class="mr15" type="primary" @click="$refs.recharge.initRechargeData('recharge')"
        v-if="getPermission('ymsDistributorMerchantRechargeRecord_recharge')">{{ $t('key1003742') }}
      </Button>
      <!--扣费按钮-->
      <Button class="mr15" type="primary" @click="$refs.recharge.initRechargeData('charging')"
        v-if="getPermission('ymsDistributorMerchantRechargeRecord_recharge')">{{ $t('key1003743') }}
      </Button>
      <!--导出数据-->
      <Dropdown transfer @on-click="changeExportBtn" v-if="getPermission('ymsDistributorMerchantRechargeRecord_exportDistributorMerchantRechargeRecord')">
        <Button type="primary">
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="500"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--充值的弹窗-->
    <rechargeModal ref="recharge" @updateData="search()"></rechargeModal>
    <!--导出订单字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1003741')"
      paramKeyColums="ymsDistributorMerchantRechargeRecordColumns"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import rechargeModal from "@/views/yms/components/financialManage/rechargeModal";
import exportFieldsModal from "@/components/common/exportFieldsModal.vue";
import {getUserNameByUserId, downloadTemplateFile, pageJump, isImageFile, getAllUsersInfo, getDataSetBatchList, getEnumName} from "@/utils/common";

export default {
  name: "rechargeRecord",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        startRechargeTime: null,
        endRechargeTime: null,
        status: 'all',
        ymsDistributorMerchantId: '',
        ymsDistributorMerchantRechargeRecordIds: '',
        pageNum: 1,
        pageSize: 15
      },
      rechargeType: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), value: 'all'},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003722'), value: 1},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'), value: 2},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003723'), value: 3}
      ],
      total: 0,
      rechargeTime: [],
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003724'),
          key: 'ymsDistributorMerchantRechargeRecordId',
          minWidth: 200,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003725'),
          key: 'paymentSerialNumber',
          minWidth: 160,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003726'),
          align: 'center',
          minWidth: 260,
          key: 'paymentPicturePath',
          render(h, params) {
            let imgList = [];
            let fileList = [];
            let paymentPicturePathList = params.row.ymsDistributorMerchantRechargeRecordImages || [];
            if (paymentPicturePathList.length > 0) {
              paymentPicturePathList.map((item) => {
                if (isImageFile(item.paymentPicturePath)) {
                  imgList.push(h('div', {class: 'm5'}, [v.tableImg(h, params,
                    null, item.paymentPicturePath, null, 'left', false, false)]));
                } else {
                  fileList.push(h('p', {
                    class: 'cursor mt2 mb2 themeColor',
                    style: {
                      textAlign: 'left'
                    },
                    on: {
                      click() {
                        if (item.paymentPicturePath) {
                          downloadTemplateFile(item.paymentPicturePath);
                        }
                      }
                    },
                  }, item.name));
                }
              });
              return h('div', [
                h('div', {class: 'flex flex-wrap'}, [imgList]),
                fileList
              ]);
            }
          },
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002877'),
          minWidth: 130,
          key: 'ymsDistributorMerchantId',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000289'),
          minWidth: 100,
          key: 'operationType',
          align: 'center',
          render(h, params) {
            let operationType = params.row.operationType;
            let text = getEnumName(v.enumData, 'YmsDistributorMerchantRechargeRecordOperationTypeCoreEnum', operationType);
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003727'),
          minWidth: 150,
          key: 'rechargeAmount',
          align: 'center',
          render(h, params) {
            let rechargeAmount = params.row.rechargeAmount;
            return rechargeAmount ? h('div', [
              h('div', v.formatCurrency(rechargeAmount)),
              h('div', '(' + params.row.currency + ')')
            ]) : h('span', '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003728'),
          key: 'balance',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let balance = params.row.balance;
            return h('div', [
              h('div', v.formatCurrency(balance)),
              h('div', '(' + params.row.balanceCurrency + ')')
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003729'),
          key: 'balanceAfterRecharge',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let amountAfterRechargeStr = params.row.amountAfterRechargeStr || 0;
            let balanceAfterRecharge = Number((Number(amountAfterRechargeStr)).toFixed(2));
            return h('div', [
              h('p', v.formatCurrency(balanceAfterRecharge)),
              h('p', '(' + params.row.balanceCurrency + ')'),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003730'),
          key: 'remainQuota',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            let remainQuota = params.row.remainQuota;
            return h('div', [
              h('div', v.formatCurrency(remainQuota)),
              h('div', '(' + params.row.remainQuotaCurrency + ')')
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003731'),
          key: 'afterRemainQuota',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            let afterRemainQuota = params.row.afterRemainQuota;
            return h('div', [
              h('div', v.formatCurrency(afterRemainQuota)),
              h('div', '(' + params.row.remainQuotaCurrency + ')')
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003187'),
          minWidth: 150,
          key: 'withholdingAmount',
          align: 'center',
          render(h, params) {
            let withholdingAmount = params.row.withholdingAmount;
            return withholdingAmount > 0 ? h('div', [
              h('div', v.formatCurrency(withholdingAmount)),
              h('div', '(' + params.row.withholdingAmountCurrency + ')')
            ]) : withholdingAmount === 0 ? h('span', 0) : h('span', '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003188'),
          minWidth: 150,
          key: 'initialQuota',
          align: 'center',
          render(h, params) {
            let initialQuota = params.row.initialQuota;
            return initialQuota > 0 ? h('div', [
              h('p', v.formatCurrency(initialQuota)),
              h('p', '(' + params.row.initialQuotaCurrency + ')'),
            ]) : initialQuota === 0 ? h('span', 0) : h('span', '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003732'),
          key: 'status',
          width: 120,
          align: 'center',
          render(h, params) {
            const statusText = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003722'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003723')];
            return h('span', statusText[params.row.status]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000291'),
          key: 'updatedTime',
          align: 'center',
          sortable: true,
          width: 170,
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.updatedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350'),
          key: 'remarks',
          align: 'center',
          width: 250,
          render(h, params) {
            return v.checkContentOverflow(h, params.row.remarks, 250, 2);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003626'),
          key: 'paymentMethod',
          minWidth: 110,
          align: 'center'
        },
        {
          key: 'createdBy',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          minWidth: 110,
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
      ],
      tableData: [],
      exportType: null,
      selectTableData: [],
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'ymsDistributorMerchantRechargeRecordId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003724')},
            {paramKey: 'paymentSerialNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003725')},
            {paramKey: 'ymsDistributorMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002877')},
            {paramKey: 'currency', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000738')},
            {paramKey: 'rechargeAmountStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003727')},
            {paramKey: 'balanceStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003728')},
            {paramKey: 'amountAfterRechargeStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003729')},
            {paramKey: 'withholdingAmountStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003187')},
            {paramKey: 'initialQuotaStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003188')},
            {paramKey: 'statusStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003733')},
            {paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000291')},
            {paramKey: 'remarks', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350')},
            {paramKey: 'paymentMethod', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003626')},
            {paramKey: 'createdBy', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292')},
            {paramKey: 'operationType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000289')},
            {paramKey: 'remainQuotaStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003734')},
            {paramKey: 'afterRemainQuota', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003735')},
          ]
        }
      ],
      userInfoList: {},
      enumData: []
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      this.setDefaultTimerParams('three_months');
      (async () => {
        let enumKeyList = ['YmsDistributorMerchantRechargeRecordOperationTypeCoreEnum'];
        this.enumData = await getDataSetBatchList(enumKeyList);
        await getAllUsersInfo().then(data => {
          this.userInfoList = data;
        });
        await this.search();
      })();
    },
    handleSuccess(response) {
      this.rechargeForm.paymentPicturePath = response.datas[0];
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.rechargeTime = [];
      v.resetDate();
      v.$refs['pageParams'].resetFields();
      v.setDefaultTimerParams('three_months');
      v.getList();
    },
    // 获取日期返回值
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.startRechargeTime = null;
          v.pageParams.endRechargeTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.rechargeTime = v.defaultTimePeriod(value, false);
          v.pageParams.startRechargeTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.endRechargeTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 重置时间
    resetDate() {
      this.pageParams.startRechargeTime = null;
      this.pageParams.endRechargeTime = null;
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      if (params.status === 'all') {
        params.status = null;
      }
      
      for (let key in params) {
        if (['ymsDistributorMerchantRechargeRecordIds'].includes(key)) {
          params[key] = v.sepCommasFn(params[key], ['\n']);
        }
      }
      return params;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsDistributorMerchantRechargeRecord_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsDistributorMerchantRechargeRecord_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data.map((item) => {
          return item.ymsDistributorMerchantRechargeRecordId;
        });
      }
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsDistributorMerchantRechargeRecordIds = v.selectTableData;
      } else {
        if (v.pageParams.ymsDistributorMerchantRechargeRecordIds) {
          query.ymsDistributorMerchantRechargeRecordIds = v.sepCommasFn(v.pageParams.ymsDistributorMerchantRechargeRecordIds, ['\n']);
        } else {
          query.ymsDistributorMerchantRechargeRecordIds = [];
        }
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          v.axios.post(api.post_ymsDistributorMerchantRechargeRecord_exportDistributorMerchantRechargeRecord, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    exportFieldsModal,
    rechargeModal
  }
};
</script>
